/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { createI } from '../../factoriesAny.js';
export var iDependencies = {
  ComplexDependencies,
  createI
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesI.generated.js
// module id = 545
// module chunks = 2